import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as api from './api'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'
import { ParamsType } from './types'

function* fetchModuleScreen(payload: ParamsType): SagaIterator {
  try {
    const { id, mid, sid } = payload
    const moduleScreen = yield effects.call(api.fetchModuleScreen, id, mid, sid)
    yield effects.put(actions.fetchModuleScreenSuccess(moduleScreen.data))
  } catch (error) {
    console.warn('Cannot fetch module screen', error)
    yield effects.put(
      actions.fetchModuleScreenFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* fetchModule(payload: ParamsType): SagaIterator {
  try {
    const { id, mid } = payload
    const module = yield effects.call(api.fetchModule, id, mid)
    yield effects.put(actions.fetchModuleSuccess(module.data))
  } catch (error) {
    console.warn('Cannot fetch module', error)
    yield effects.put(actions.fetchModuleFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* fetchModulesList(payload: { id: string }): SagaIterator {
  try {
    const modulesList = yield effects.call(api.fetchModulesList, payload.id)
    yield effects.put(actions.fetchModulesListSuccess(modulesList.data))
  } catch (error) {
    console.warn('Cannot fetch modules list', error)
    yield effects.put(
      actions.fetchModulesListFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* fetchCourseUserState(payload: { id: string }): SagaIterator {
  try {
    const userState = yield effects.call(api.fetchCourseUserState, payload.id)
    yield effects.put(actions.fetchCourseUserStateSuccess(userState.data))
  } catch (error) {
    console.warn('Cannot fetch course user state', error)
    yield effects.put(
      actions.fetchCourseUserStateFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* fetchAchievements(payload: { period: string }): SagaIterator {
  try {
    const achievements = yield effects.call(
      api.fetchAchievements,
      payload.period
    )
    yield effects.put(actions.fetchAchievementsSuccess(achievements.data))
  } catch (error) {
    console.warn('Cannot fetch achievements', error)
    yield effects.put(
      actions.fetchAchievementsFailure(formatErrorMessage(error))
    )
    Sentry.captureException(error)
  }
}

function* watchFetchModuleScreen(): SagaIterator {
  yield effects.takeEvery(
    actions.fetchModuleScreen.toString(),
    fetchModuleScreen
  )
}

function* watchFetchModule(): SagaIterator {
  yield effects.takeEvery(actions.fetchModule.toString(), fetchModule)
}

function* watchFetchModulesList(): SagaIterator {
  yield effects.takeEvery(actions.fetchModulesList.toString(), fetchModulesList)
}

function* watchFetchCourseUserState(): SagaIterator {
  yield effects.takeEvery(
    actions.fetchCourseUserState.toString(),
    fetchCourseUserState
  )
}

function* watchFetchAchievements(): SagaIterator {
  yield effects.takeEvery(
    actions.fetchAchievements.toString(),
    fetchAchievements
  )
}

export default function* watchModuleScreen(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchModuleScreen),
    effects.fork(watchFetchModule),
    effects.fork(watchFetchModulesList),
    effects.fork(watchFetchCourseUserState),
    effects.fork(watchFetchAchievements),
  ])
}
